import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/FirebaseAuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading, userPreferences } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // If user hasn't completed onboarding, redirect to onboarding
  if (!userPreferences?.hasCompletedOnboarding) {
    return <Navigate to="/onboarding/genres" />;
  }

  return <>{children}</>;
};

export default PrivateRoute; 